// COTAERU: Fix broken collection URLs for English market
(function() {
  if (!/^\/(en-us|us)(\/|$)/.test(location.pathname)) return;
  function fix() {
    document.querySelectorAll('a[href]').forEach(function(a) {
      var h = a.getAttribute('href');
      if (!h) return;
      // /en-uscollections/... → /en-us/collections/...
      if (h.match(/^\/en-us[^\/]/)) {
        a.setAttribute('href', '/en-us/' + h.slice(6).replace(/^\//, ''));
      }
      // en-us/collections/... (no leading slash) → /en-us/collections/...
      if (h.match(/^en-us\//)) {
        a.setAttribute('href', '/' + h);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
